/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Meta_DescriptionInputs */

const en_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf lesson pricing, range ball bucket prices, and gift cards at Mark Egly Golf in Des Moines, Iowa.`)
};

const es_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios de lecciones de golf, cubetas de pelotas y tarjetas de regalo en Mark Egly Golf en Des Moines, Iowa.`)
};

const de_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise für Golfstunden, Preise für Rangeball-Eimer und Geschenkkarten bei Mark Egly Golf in Des Moines, Iowa.`)
};

const zh_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`爱荷华州得梅因 Mark Egly Golf 的高尔夫课程价格、练习场球桶价格和礼品卡。`)
};

const ar_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أسعار دروس الغولف، أسعار سلال كرات الميدان، وبطاقات الهدايا في Mark Egly Golf في Des Moines, Iowa.`)
};

const fr_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifs des cours de golf, prix des seaux de balles de golf et cartes-cadeaux au Mark Egly Golf à Des Moines, Iowa.`)
};

const vi_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá bài học golf, giá xô bóng sân tập, và thẻ quà tặng tại Mark Egly Golf ở Des Moines, Iowa.`)
};

const sw_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei za masomo ya gofu, bei za ndoo za mipira ya uwanja wa mazoezi, na kadi za zawadi katika Mark Egly Golf huko Des Moines, Iowa.`)
};

const th_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคาบทเรียนกอล์ฟ ราคาถังลูกกอล์ฟ และบัตรของขวัญที่ Mark Egly Golf ในเมืองดิมอยน์ รัฐไอโอวา`)
};

const bs_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cijene lekcija golfa, cijene kanti loptica i poklon kartice kod Mark Egly Golf u Des Moinesu, Iowa.`)
};

const ja_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイオワ州デモインの Mark Egly Golf のゴルフレッスン料金、ドライビングレンジのボールバケット料金、ギフトカード。`)
};

const ko_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이오와주 데모인 Mark Egly Golf의 골프 레슨 가격, 드라이빙 레인지 볼 버킷, 기프트 카드.`)
};

const pt_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços de aulas de golfe, de baldes de bolas para o driving range e cartões-presente na Mark Egly Golf em Des Moines, Iowa.`)
};

const it_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi delle lezioni di golf, dei cestini di palline per il campo pratica e carte regalo da Mark Egly Golf a Des Moines, Iowa.`)
};

const sv_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser på golflektioner, bollhinkar för drivingrangen och presentkort hos Mark Egly Golf i Des Moines, Iowa.`)
};

const nl_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijzen voor golflessen, ballenemmers voor de driving range en cadeaukaarten bij Mark Egly Golf in Des Moines, Iowa.`)
};

const da_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser på golflektioner, priser på boldkurve til drivingrangen og gavekort hos Mark Egly Golf i Des Moines, Iowa.`)
};

const nb_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser på golftimer, priser på ballkurver til drivingrangen og gavekort hos Mark Egly Golf i Des Moines, Iowa.`)
};

const fi_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golftuntien hinnat, rangepallokorien hinnat ja lahjakortit – Mark Egly Golf, Des Moines, Iowa.`)
};

const pl_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny lekcji golfa, ceny koszyków piłek na driving range i karty podarunkowe w Mark Egly Golf w Des Moines w stanie Iowa.`)
};

const ru_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены на уроки гольфа, на корзины мячей для драйвинг-рейнджа и подарочные карты в Mark Egly Golf в Des Moines, Iowa.`)
};

const tr_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa'daki Mark Egly Golf'te golf dersi fiyatları, driving range top kovası fiyatları ve hediye kartları.`)
};

const hi_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa में Mark Egly Golf में गोल्फ पाठ मूल्य निर्धारण, रेंज बॉल बाल्टी की कीमतें और उपहार कार्ड।`)
};

const id_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga pelajaran golf, harga ember bola driving range, dan kartu hadiah di Mark Egly Golf di Des Moines, Iowa.`)
};

const ms_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga pelajaran golf, harga baldi bola latihan dan kad hadiah di Mark Egly Golf di Des Moines, Iowa.`)
};

const cs_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny golfových lekcí, ceny košíků míčků na driving range a dárkové karty v Mark Egly Golf v Des Moines v Iowě.`)
};

const el_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τιμές μαθημάτων γκολφ, τιμές για κουβάδες με μπάλες του driving range και δωροκάρτες στο Mark Egly Golf στο Des Moines της Αϊόβα.`)
};

const he_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחירי שיעורי גולף, מחירי דליי כדורים למגרש האימונים וכרטיסי מתנה ב-Mark Egly Golf ב-Des Moines, Iowa.`)
};

const af_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golflespryse, balemmerpryse en geskenkkaarte by Mark Egly Golf in Des Moines, Iowa.`)
};

const hu_prices_meta_description = /** @type {(inputs: Prices_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfórák árai, driving range labdakosarak árai és ajándékkártyák a Mark Egly Golfnál, Des Moines-ban (Iowa).`)
};

/**
* | output |
* | --- |
* | "Golf lesson pricing, range ball bucket prices, and gift cards at Mark Egly Golf in Des Moines, Iowa." |
*
* @param {Prices_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_meta_description = /** @type {((inputs?: Prices_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_meta_description(inputs)
	if (locale === "de") return de_prices_meta_description(inputs)
	if (locale === "zh") return zh_prices_meta_description(inputs)
	if (locale === "ar") return ar_prices_meta_description(inputs)
	if (locale === "fr") return fr_prices_meta_description(inputs)
	if (locale === "vi") return vi_prices_meta_description(inputs)
	if (locale === "sw") return sw_prices_meta_description(inputs)
	if (locale === "th") return th_prices_meta_description(inputs)
	if (locale === "bs") return bs_prices_meta_description(inputs)
	if (locale === "ja") return ja_prices_meta_description(inputs)
	if (locale === "ko") return ko_prices_meta_description(inputs)
	if (locale === "pt") return pt_prices_meta_description(inputs)
	if (locale === "it") return it_prices_meta_description(inputs)
	if (locale === "sv") return sv_prices_meta_description(inputs)
	if (locale === "nl") return nl_prices_meta_description(inputs)
	if (locale === "da") return da_prices_meta_description(inputs)
	if (locale === "nb") return nb_prices_meta_description(inputs)
	if (locale === "fi") return fi_prices_meta_description(inputs)
	if (locale === "pl") return pl_prices_meta_description(inputs)
	if (locale === "ru") return ru_prices_meta_description(inputs)
	if (locale === "tr") return tr_prices_meta_description(inputs)
	if (locale === "hi") return hi_prices_meta_description(inputs)
	if (locale === "id") return id_prices_meta_description(inputs)
	if (locale === "ms") return ms_prices_meta_description(inputs)
	if (locale === "cs") return cs_prices_meta_description(inputs)
	if (locale === "el") return el_prices_meta_description(inputs)
	if (locale === "he") return he_prices_meta_description(inputs)
	if (locale === "af") return af_prices_meta_description(inputs)
	if (locale === "hu") return hu_prices_meta_description(inputs)
	return en_prices_meta_description(inputs)
});